var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"72"}})],1),_c('v-col',{attrs:{"cols":"12","align":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }